import {
  Box,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import TextButtonComponet from "../../atom/Buttons/TextButton";
import { Card } from "@mui/material";
import { CardMedia } from "@mui/material";
import defaultVideoThumbnail from "../../../assets/Images/video_thumbnail.jpg";
import { getThumbnailSrc } from "../../../core/Constant";

const SampleVideoCard = ({
  week,
  data,
  thumbnail,
  btnText,
  description,
  title,
  onViewVideo = () => { },
}) => {

  const image = getThumbnailSrc(thumbnail, "video_thumbnail") || defaultVideoThumbnail;

  return (


    <Card
      sx={{
        width: "100%",
        height: { xs: 350, sm: 370, lg: 385 },
        minWidth: 0,
        display: "flex",
        flexDirection: "column",
        borderRadius: 3,
        overflow: "hidden",
        border: "1px solid #e5e5e5",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.14)",
      }}
    >
      <Box
        sx={{
          position: "relative",
          height: { xs: 180, sm: 190, lg: 200 },
          flex: { xs: "0 0 180px", sm: "0 0 190px", lg: "0 0 200px" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundImage:
            "linear-gradient(to top, #2d3945, #292b34, #211e24, #161214, #000000)",
        }}
      >
        <CardMedia
          component="img"
          height="180"
          image={image}
          alt="Card-image"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            opacity: 0.95,
          }}
          onError={(event) => {
            if (event.currentTarget.src !== defaultVideoThumbnail) {
              event.currentTarget.src = defaultVideoThumbnail;
            }
          }}
        />
      </Box>
      <CardContent sx={{ p: 2, display: "flex", flexDirection: "column", gap: 0.5, flexGrow: 1, minWidth: 0 }}>
        {title && (
          <Typography
            title={title}
            sx={{
              fontSize: 13,
              fontWeight: 500,
              fontFamily: "Montserrat",
              display: "-webkit-box",
              overflow: "hidden",
              textOverflow: "ellipsis",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              minHeight: 38,
              color: "#8C8C8C",
              lineHeight: 1.4,
            }}
          >
            {title}
          </Typography>
        )}
        {description && (
          <Typography
            title={description}
            sx={{
              fontSize: 15,
              fontWeight: 700,
              fontFamily: "Montserrat",
              color: "#1E293B",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {description}
          </Typography>
        )}
      </CardContent>
      <CardActions sx={{ p: 2, pt: 0, mt: "auto" }}>
        <TextButtonComponet onButtonClick={onViewVideo} text={btnText} classStyle="btn btn-100 btn-primary" />
      </CardActions>
    </Card>
  );

};

export default SampleVideoCard;

